import React, { useEffect } from "react";
import { formatNumber } from "@/util/sums";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext } from "react-hook-form";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const getHomeValueFields = () => {
  return {
    defaultValue: 2500000,
    minAmount: 500000,
    maxAmount: 20000000,
  };
};

const fieldName = CalculatorField.HomeValue;

const HomeEstimatedValue: React.FC<ControlledFormField> = ({ fieldPrefix }) => {
  const targetName = [fieldPrefix, fieldName].filter(Boolean).join(".");

  const { control, setValue } = useFormContext();
  const { defaultValue, ...minMaxParams } = getHomeValueFields();

  const { field } = useController({
    control,
    name: [fieldPrefix, fieldName].filter(Boolean).join("."),
    defaultValue,
  });

  useEffect(() => {
    // workaround to trigger subscribed fields with the default value at initial render
    setTimeout(() => setValue(targetName, defaultValue), 0);
  }, []);

  return (
    <ColFormValueSlider
      title="Estimate the value of the property"
      step={1000}
      value={field.value}
      {...minMaxParams}
      rightColumnValue={field.value}
      rightColumnFormatFunction={(value) => `$${formatNumber(value, 0, true)}`}
      onFinalChange={field.onChange}
      onChange={field.onChange}
    />
  );
};

export default HomeEstimatedValue;
